export default "__VITE_ASSET__Db8TyWbm__"